import { defineMessages } from '@alltrails/shared/react-intl';

const OUR_VALUES_STRINGS = defineMessages({
  SpreadStoke: {
    defaultMessage: 'Spread the stoke'
  },
  SpreadStokeDesc: {
    defaultMessage: 'Sharing great trails with like-minded nature lovers is what we live for.'
  },
  LeadByExample: {
    defaultMessage: 'Lead by example'
  },
  LeadByExampleDesc: {
    defaultMessage: 'The trails we love are the legacy we leave for future generations.'
  },
  EmbraceChange: {
    defaultMessage: 'Embrace change'
  },
  EmbraceChangeDesc: {
    defaultMessage: 'From fallen trees to sudden rain, obstacles are what we make of them.'
  },
  DownToEarh: {
    defaultMessage: 'Stay down to earth'
  },
  DownToEarhDesc: {
    defaultMessage: 'Our love of the trail is at the heart of everything we do.'
  },
  AllWelcome: {
    defaultMessage: 'All are welcome'
  },
  AllWelcomeDesc: {
    defaultMessage: 'Hikers, bikers, roamers, strollers — if you’re out there, we’re with you.'
  }
});

export default OUR_VALUES_STRINGS;
